import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import App from './App';
import Dialogs from './components/Dialogs';
import { store } from './store';
import { GlobalStyle } from './views/styles/GlobalStyle';
import { Themes } from './views/styles/Themes';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={Themes}>
      <Provider store={store}>
        <GlobalStyle />
        <App />
        <Dialogs />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);